import { SystemLabel } from './system-label';

export class NewSystemLabel extends SystemLabel {
  getSortOrderTitle(): string {
    return 'New';
  }
}
